import styled from "styled-components";
import { desktop } from "../../constants/globalStyleVariables";

export const MySubLabel = styled.dt`
    opacity: 0.5;
    font-size: 0.8rem;
    margin-bottom: ${desktop.formElements.labelSeparation};
`